/**
 * Adapter to convert modern ExposureBreakdown to legacy IMaterialExposure format
 * This allows us to use the new calculation system with existing UI components
 */

import { ExposureBreakdown } from './exposureCalculation';
import { IMaterialExposure } from '../sp-types/netExposureType';

/**
 * Convert ExposureBreakdown to IMaterialExposure format for legacy UI components
 * Uses base currency values for consistency
 */
export const exposureBreakdownToMaterialExposure = (
  breakdown: ExposureBreakdown
): IMaterialExposure => {
  return {
    futureOrder: breakdown.demand.valueBase,
    inventorySum: breakdown.supply.valueBase,
    financialPositions: breakdown.hedges.valueBase,
    futureExpCalendar: [],
    positionExpCalendar: [],
  };
};

/**
 * Calculate net exposure value from breakdown
 * Formula: Demand - Supply - Hedges
 * Returns value in base currency
 */
export const calculateNetExposureValue = (breakdown: ExposureBreakdown): number => {
  return breakdown.netExposure.valueBase;
};
